import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomPagination from "../../CustomPagination";
import PuffLoader from "react-spinners/PuffLoader";
import "./YoutubeData.css";
import { useLoadTypeContentData } from "../../../../Utils/customHooks/UpToDateContent/useLoadTypeContent";
import { BsHourglassSplit, BsLink45Deg } from "react-icons/bs";
import Card from "react-bootstrap/esm/Card";
import DataSkeleton from "../DataSkeleton";
import { debounce } from "lodash";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { handleFirstImage, handleNavigate, isNavigable, updateIsEmptyStatus } from "../../../../Utils/StayUpToDate/RenderComponent";
import track, {
  TRACKING_TYPES,
} from "../../../../Utils/SupabaseServices/Track";
import { isMobile } from "react-device-detect";
import { useDomLoaded } from "../../../../hooks/DomLoadedContext";
import ImagePostTag from "../../../GeneralPostTag/ImagePostTag";
import FrontendTemplate from "../StructureTemplates/FrontendTemplate";

const YoutubeData = (props: any) => {
  let platform = "youtube";
  let type = "VIDEO";
  const itemsPerPage = 3;
  const {
    user_id,
    username,
    handleRedirect,
    brand_color,
    isHandleNavigate,
    component,
    removedPostIds,
    isLinks,
    title,
    from,
  } = props;
  const { isLoading: YoutubeDataLoading, data: YoutubeData }: any =
    useLoadTypeContentData(
      username,
      user_id,
      platform,
      type,
      removedPostIds,
      component?.content_order
    );

  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef<any>(null);
  const isButtonClicked = useRef(false);
  const param = useParams();
  const location = useLocation();
  const domLoaded = useDomLoaded();
  const navigate = useNavigate();

  const handleScroll = useCallback(
    debounce(() => {
      if (!isButtonClicked.current) {
        if (containerRef.current) {
          const scrollLeft = containerRef.current.scrollLeft;
          const itemWidth =
            containerRef.current.scrollWidth / YoutubeData.length;
          const newCurrentIndex = Math.round(scrollLeft / itemWidth);
          setCurrentIndex(newCurrentIndex);
        }
      }
    }, 100),
    [YoutubeData]
  );
  useEffect(() => {
    const checkEmptyStatus = async () => {
      if (!YoutubeDataLoading) {
        if (!YoutubeData || YoutubeData.total_count === 0) {
          await updateIsEmptyStatus(title, user_id, component.id);
          // setIsLoading(false);
        } else {
          await handleFirstImage(title, component?.id, YoutubeData?.[0],user_id);
          // setIsLoading(false);
        }
      }
    };
    checkEmptyStatus();
  }, [YoutubeDataLoading, YoutubeData]);

  useEffect(() => {
    if (containerRef.current) {
      const itemWidth = containerRef.current.scrollWidth / YoutubeData.length;
      const scrollPosition = itemWidth * currentIndex;
      containerRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  }, [currentIndex, YoutubeData]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.addEventListener("scroll", handleScroll);
      return () => {
        if (containerRef.current) {
          containerRef.current.removeEventListener("scroll", handleScroll);
        }
      };
    }
  }, [YoutubeData, handleScroll]);

  const handlePrevPage = () => {
    isButtonClicked.current = true;
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    setTimeout(() => {
      isButtonClicked.current = false;
    }, 500);
  };

  const handleNextPage = () => {
    isButtonClicked.current = true;
    setCurrentIndex((prevIndex) =>
      Math.min(prevIndex + 1, YoutubeData.length - itemsPerPage)
    );
    setTimeout(() => {
      isButtonClicked.current = false;
    }, 500);
  };

 
  return (
    <div>
      {YoutubeDataLoading || !domLoaded ? (
        <DataSkeleton />
      ) : (
        <>
          {YoutubeData && YoutubeData.length > 0 ? (
            <div>
              <div className="mainDiv">
                <p
                  className="component-name"
                  style={param?.id ? { cursor: "auto" } : {}}
                  onClick={(e) => handleNavigate(navigate,location,username,user_id,component,from)}
                >
                  {" "}
                  {component?.name}
                </p>
                {!param?.id && (
                  <CustomPagination
                    totalItems={YoutubeData?.length}
                    currentIndex={currentIndex}
                    handlePrevPage={handlePrevPage}
                    handleNextPage={handleNextPage}
                  />
                )}
              </div>
            
               <FrontendTemplate
                param={param}
                containerRef={containerRef}
                isMobile={isMobile}
                data={YoutubeData}
                handleRedirect={handleRedirect}
                brand_color={brand_color}
                isLinks={isLinks}
                type={type}
                title={title}
                component={component}
                user_id={user_id}
                username={username}
                from={from}

              />
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};

export default YoutubeData;
